import { render, staticRenderFns } from "./CardPage.vue?vue&type=template&id=c3ca9a28&scoped=true&"
import script from "./CardPage.vue?vue&type=script&lang=js&"
export * from "./CardPage.vue?vue&type=script&lang=js&"
import style0 from "./CardPage.vue?vue&type=style&index=0&id=c3ca9a28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ca9a28",
  null
  
)

export default component.exports